// @flow
import React from "react";
import classNames from "classnames";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { IconStylesClassesType } from "../../styles/iconStyles";
import { iconStyles } from "../../styles/iconStyles";
import LoadingProgress from "../Gadgets/LoadingProgress";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...iconStyles(theme),
  rightMargin: {
    marginRight: "10px"
  }
});

type SubmitButtonClassesType = {
  ...IconStylesClassesType,
  rightMargin: DictionaryType
};

type DeleteButtonPropsType = {
  classes: SubmitButtonClassesType,
  loading: boolean,
  onClick: Function,
  noMargin?: boolean
};

const DeleteButton = (props: DeleteButtonPropsType): React$Element<*> => {
  if (props.loading) {
    return (
      <IconButton
        aria-label="Delete"
        className={!props.noMargin && props.classes.rightMargin}
      >
        <LoadingProgress size={20} />
      </IconButton>
    );
  } else {
    return (
      <IconButton
        aria-label="Delete"
        className={!props.noMargin && props.classes.rightMargin}
        onClick={props.onClick}
      >
        <DeleteIcon className={props.classes.shineIcon} />
      </IconButton>
    );
  }
};

export default withStyles(styles)(DeleteButton);
